import { create } from 'zustand';
import { getKnowledgeBaseResponse } from '@/services/data/knowledgeBase';
import type { KnowledgeBaseResponse } from '@/services/data/knowledgeBase';

interface KnowledgeBaseState {
  isComplete: boolean;
  isLoading: boolean;
  userId: string | null;
  checkKnowledgeBase: (userId: string) => Promise<void>;
  refetch: () => Promise<void>;
}

export const useKnowledgeBaseStore = create<KnowledgeBaseState>((set, get) => ({
  isComplete: true,
  isLoading: true,
  userId: null,

  checkKnowledgeBase: async (userId: string) => {
    set({ isLoading: true, userId });
    
    try {
      const result = await getKnowledgeBaseResponse(userId);
      
      if (!result.success || !result.data) {
        set({ isComplete: false, isLoading: false });
        return;
      }

      // Cast to access new columns not yet in generated types
      const kb = result.data as KnowledgeBaseResponse & { media_links?: string[] };
      
      // Check text fields
      const textFields: (keyof KnowledgeBaseResponse)[] = [
        'objectif',
        'domaines_parole',
        'unique_different'
      ];
      
      const textFieldsFilled = textFields.every(field => {
        const value = kb[field];
        return value && typeof value === 'string' && value.trim().length > 0;
      });
      
      // Check cible (jsonb array)
      const cibleData = kb.cible as string[] | null;
      const cibleFilled = cibleData && Array.isArray(cibleData) && cibleData.length > 0 && cibleData.some(v => v.trim() !== '');

      const allFieldsFilled = textFieldsFilled && cibleFilled;

      set({ isComplete: allFieldsFilled, isLoading: false });
    } catch (error) {
      console.error('Error checking knowledge base:', error);
      set({ isComplete: false, isLoading: false });
    }
  },

  refetch: async () => {
    const { userId } = get();
    if (userId) {
      await get().checkKnowledgeBase(userId);
    }
  }
}));
